export const styles = {
    multiSelectBox: { width: { xs: "100%", sm: "50%" }, pr: { sm: 1, md: 2 }, mb: { sm: 2, md: 1 }, mt: { sm: 2, md: 1 } },
    inputStyle: {
        '& .MuiInputBase-root': {
                                border: '1px solid white',
        borderRadius: '5px',
        "& .MuiOutlinedInput-root": { color: '# ' }
                        },
      },
      tagStyle: {
        backgroundColor: '#F6F6F8',
        height: "26px",
        fontSize: "10px",
        borderRadius: '6px',
        color: '#A1A1A1',
        margin: '2px',
        '& .MuiChip-deleteIcon': {
                                    color: '#A1A1A1',
        height: "14px"
                                
                            },
      },

}